import type { Project } from '../types/content'

// Titles and subtitles are taken word for word from the live Work collection on immersivestudios.de.
// Images: real thumbnails from the Webflow assets where available (Project Cars, Jewlery, OLA, Radical Solutions,
// Erfolgsmensch). The rest are stand-ins until their real files are added.
// Videos: every card plays on hover. Until each project's own clip is added, they share the showreel preview.
const SHOWREEL_PREVIEW = 'https://cdn.magicpatterns.com/uploads/hF89wxx41eCLkJUhZcKifw/showreel-preview-mini-transcode.webm'

export const projects: Project[] = [
  {
    title: 'LUKSO.network',
    subtitle: 'Blockchain for Social Creator Culture',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/197a4687-6134-49cf-9fd4-49f369b0903b.jpg',
    video: SHOWREEL_PREVIEW,
    href: '#',
    layout: 'nudge-flush',
    aspect: 'landscape-small',
  },
  {
    title: 'Project Cars: A Real-Time Car Configuration Experience',
    image: 'https://cdn.magicpatterns.com/uploads/pogFZLCUuhR5HZCdAKJvgq/Project-Cars.png',
    video: SHOWREEL_PREVIEW,
    href: '#',
    layout: 'full',
    aspect: 'square',
  },
  {
    title: 'Windland - Immersive city experience',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/29b7aee8-4199-42a6-a507-aae7b7861ad9.jpg',
    video: SHOWREEL_PREVIEW,
    href: '#',
    layout: 'full',
    aspect: 'landscape-big',
  },
  {
    title: 'Jewlery 3D Configurator',
    subtitle: 'Real-time configurator',
    image: 'https://cdn.magicpatterns.com/uploads/wB6pEimKbppM8bypHvJvwZ/Unique-Jewllery.png',
    video: SHOWREEL_PREVIEW,
    href: '#',
    layout: 'medium',
    aspect: 'square',
  },
  {
    title: 'Immersive Concert Hall - VR seat booking',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/ed0c50a2-5b83-4242-9da3-7272241cca60.jpg',
    video: SHOWREEL_PREVIEW,
    href: '#',
    layout: 'full',
    aspect: 'landscape-medium',
  },
  {
    title: 'Project Haunted House: A Scrollytelling Experience',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b8ef40d5-c7f8-4c4c-bb2b-f421f9950c67.jpg',
    video: SHOWREEL_PREVIEW,
    href: '#',
    layout: 'nudge',
    aspect: 'landscape-small',
  },
  {
    title: 'OLA Research Lab - Visual exploration',
    subtitle: '3D web experience',
    image: 'https://cdn.magicpatterns.com/uploads/n4chMg7hN23nz8NNXLVtyK/Ola-Research-Lab.png',
    video: SHOWREEL_PREVIEW,
    href: '#',
    layout: 'medium',
    aspect: 'square',
  },
  {
    title: 'Radical Solutions',
    image: 'https://cdn.magicpatterns.com/uploads/6PX91txBpR6aZjLDCGCxon/Radical-Solutions.png',
    video: SHOWREEL_PREVIEW,
    href: '#',
    layout: 'full',
    aspect: 'landscape-medium',
  },
  {
    title: 'Fuel.network',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/6fc04b6c-2056-491f-9a64-0976deb94fc6.jpg',
    video: SHOWREEL_PREVIEW,
    href: '#',
    layout: 'nudge',
    aspect: 'landscape-small',
  },
  {
    title: 'Superluxury.io',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/a69e555f-21ac-4ac7-b839-b89e77a6727d.jpg',
    video: SHOWREEL_PREVIEW,
    href: '#',
    layout: 'full',
    aspect: 'landscape-big',
  },
  {
    title: 'Erfolgsmensch.de',
    image: 'https://cdn.magicpatterns.com/uploads/9CLq13SpApxfAkNoJ4BMS4/image-3_1-p-1600.avif',
    video: SHOWREEL_PREVIEW,
    href: '#',
    layout: 'small',
    aspect: 'landscape-tiny',
  },
]
